import { FC, ReactNode } from "react";
import { DrawerProps, Grid, ModalProps } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import Carrier, { CarrierHelpers } from "../Carrier/Carrier";
import AppModal from "../AppModal/AppModal";

export type ResponsiveSheetProps = {
  renderTrigger: (helpers: CarrierHelpers) => ReactNode;
  renderSheet: (helpers: CarrierHelpers) => ReactNode;
  label?: ReactNode;
  showTitle?: boolean;
  modalProps?: Partial<Omit<ModalProps, "open" | "title" | "footer">>;
  drawerProps?: Partial<DrawerProps>;
};

const ResponsiveSheet: FC<ResponsiveSheetProps> = ({ modalProps, drawerProps, ...props }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return isLargeScreen ? <AppModal {...props} {...modalProps} /> : <Carrier {...props} {...drawerProps} />;
};

export default ResponsiveSheet;
